import {
  EXTRA_LARGE_VIEWPORT,
  LARGE_VIEWPORT,
  MEDIUM_VIEWPORT,
  SMALL_VIEWPORT,
} from "../../../../../state/modules/layout";

export const EXTRA_LARGE_VIEWPORT_MIN_SIZE = 1322;

export const GRID_EXPANSION_COLUMN_COUNT = {
  [SMALL_VIEWPORT]: 2,
  [MEDIUM_VIEWPORT]: 3,
  [LARGE_VIEWPORT]: 4,
  [EXTRA_LARGE_VIEWPORT]: 6,
};

const getGridExpansionLayout = ({
  clientWidth,
  hasCuratedElevatedProductTiles,
  viewportCategory,
}) => {
  const gridViewportCategory =
    clientWidth >= EXTRA_LARGE_VIEWPORT_MIN_SIZE &&
    !hasCuratedElevatedProductTiles
      ? EXTRA_LARGE_VIEWPORT
      : viewportCategory || LARGE_VIEWPORT;

  return {
    viewportCategory: gridViewportCategory,
    columnCount: GRID_EXPANSION_COLUMN_COUNT[gridViewportCategory],
  };
};

export default getGridExpansionLayout;
